module.exports = __webpack_public_path__ + "media/packs/images/flags/MT-36d0e511b282f8973b8934fcaa60474c.svg";